// extracted by mini-css-extract-plugin
export default {"link":"RouteError_link__UZn51","error-msg":"RouteError_error-msg__I0sVX"};